export const getImagesAndCards = cards => {
  // filter out images and cleanup cards.
  const imageElements = [];
  const newCards = [];

  cards.forEach(card => {
    const newCard = { ...card };
    const newStoryElemets = [];

    card["story-elements"].forEach(element => {
      if (element.type === "image" || element.subtype === "image-gallery") {
        if (element.type === "composite" ) {
          imageElements.push(...element["story-elements"]);
        } else {
          imageElements.push({ ...element });
        }
      } else {
        newStoryElemets.push({ ...element });
      }
    });

    newCard["story-elements"] = newStoryElemets;
    newCards.push(newCard);
  });

  return { imageElements, newCards };
};
